import Vue from 'vue'

const self = Vue.prototype

export default {
  getAllAddressByUser() {
    return new Promise((resolve, reject) => {
      self.axios.get(self.$apiRouter.address)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getAllCountry() {
    return new Promise((resolve, reject) => {
      self.axios.get(self.$apiRouter.country)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getAllCityForMongolia() {
    return new Promise((resolve, reject) => {
      self.axios.get(self.$apiRouter.city)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getAllDistrictForMongolia(id) {
    return new Promise((resolve, reject) => {
      self.axios.get(self.$apiRouter.district + '?city_id=' + id)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getAllSubDistrictForMongolia(id) {
    return new Promise((resolve, reject) => {
      self.axios.get(self.$apiRouter.subdistrict + '?district_id=' + id)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getAutocompleteKorea(query) {
    return new Promise((resolve, reject) => {
      self.axios.post(self.$apiRouter.koreanAddress, query)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getAddressFromBook(id) {
    return new Promise((resolve, reject) => {
      self.axios.get(self.$apiRouter.getAddress+id)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  deleteAddressFromBook(id) {
    return new Promise((resolve, reject) => {
      self.axios.delete(self.$apiRouter.removeAddress+id)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  updateAddressInBook(address, id){
    return new Promise((resolve, reject) => {
      self.axios.put(self.$apiRouter.updateAddress+id, address)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  saveNewAddressFromUser(address) {
    return new Promise((resolve, reject) => {
      self.axios.post(self.$apiRouter.updateAddress, address)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getMnRegion(zip) {
    return new Promise((resolve, reject) => {
      self.axios.get(self.$apiRouter.mnRegion+zip)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
    })
  },
}
